<template>
  <el-dialog
    title="新增订单"
    :visible.sync="dialogVisible"
    width="800px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <el-form
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="140px"
      size="small"
    >
      <!-- 订单基本信息 -->
      <el-form-item label="订单名称：" prop="order_no">
        <el-input v-model="createForm.order_no" placeholder="请输入合同名称"></el-input>
      </el-form-item>
      <el-form-item label="系统订单号：" prop="contract_no">
        <el-input v-model="createForm.contract_no" placeholder="请输入u9等系统订单号"></el-input>
      </el-form-item>
      <el-form-item label="客户名称：" prop="customer_name">
        <el-input v-model="createForm.customer_name" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="销售人员：" prop="ext_01">
        <el-input v-model="createForm.ext_01" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="资源类型：" prop="resource_type">
        <el-input v-model="createForm.resource_type" placeholder="请输入资源类型（例如：H100 16台，管理节点1个）"></el-input>
      </el-form-item>
      <el-form-item label="订单类型：" prop="order_type">
        <el-select v-model="createForm.order_type" placeholder="请选择订单类型" style="width: 100%;">
          <el-option label="开口" :value="0"></el-option>
          <el-option label="闭口" :value="1"></el-option>
          <el-option label="售前测试" :value="2"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="账单日：" prop="billing_day">
        <el-input v-model="createForm.billing_day" placeholder="请输入账单日（如：5）"></el-input>
      </el-form-item>
      <el-form-item label="总价：" prop="total_price">
        <el-input v-model="createForm.total_price" placeholder="请输入总价">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="设备数量：" prop="dev_number">
        <el-input v-model="createForm.dev_number" placeholder="请输入设备数量"></el-input>
      </el-form-item>
      <el-form-item label="货币类型：" prop="currency">
        <el-select v-model="createForm.currency" placeholder="请选择货币类型" style="width: 100%;">
          <el-option label="CNY" value="CNY"></el-option>
          <el-option label="USD" value="USD"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择订单状态" style="width: 100%;">
          <el-option label="草稿" :value="0"></el-option>
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="生效中" :value="2"></el-option>
          <el-option label="已终止" :value="3"></el-option>
          <el-option label="已到期" :value="4"></el-option>
        </el-select>
      </el-form-item>

      <!-- 价格明细 -->
      <el-form-item label="价格明细：" prop="price_items">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openAddPriceDialog">添加价格</el-button>

        <!-- 价格明细列表 -->
        <el-table :data="createForm.price_items" size="small" style="margin-top: 10px;" border>
          <el-table-column prop="name" label="项目名称" min-width="120"></el-table-column>
          <el-table-column prop="specifications" label="规格说明" min-width="100"></el-table-column>
          <el-table-column prop="dev_character" label="资源类型" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.dev_character }}
            </template>
          </el-table-column>
          <el-table-column label="计费单位" min-width="80">
          <template slot-scope="scope">
            {{ unitLabelMap[scope.row.metering_unit] || scope.row.metering_unit }}
          </template>
        </el-table-column>
          <el-table-column prop="unit_price" label="单价）" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.unit_price }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">
                {{ scope.row.status === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editPriceItem(scope.$index, scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="small" style="color: #F56C6C;" @click="removePriceItem(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="订单起始时间：" prop="starting_time">
        <el-date-picker
          v-model="createForm.starting_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
          style="width: 100%;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单结束时间：" prop="end_time">
        <el-date-picker
          v-model="createForm.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
          style="width: 100%;"
        ></el-date-picker>
      </el-form-item>

      <!-- 上传附件 -->
      <!-- <el-form-item label="上传附件：">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemoveAttachment"
          :file-list="fileList"
          :before-upload="beforeUpload"
          multiple
          accept=".pdf,.doc,.docx,.txt,.xlsx,.zip"
          list-type="text"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持格式：.pdf, .doc, .docx, .txt, .xlsx, .zip</div>
        </el-upload>
      </el-form-item> -->
    </el-form>

    <!-- 添加价格弹窗 -->
    <el-dialog
      title="添加价格明细"
      :visible.sync="priceDialogVisible"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      @close="editIndex = -1"
    >
      <el-form :model="tempPriceItem" :rules="priceRules" ref="priceForm" label-width="100px" size="small">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="tempPriceItem.name" placeholder="请输入收费项目名称（例如：H100 智算节点）"></el-input>
        </el-form-item>
        <el-form-item label="规格说明：" prop="specifications">
          <el-input v-model="tempPriceItem.specifications" placeholder="请输入规格说明"></el-input>
        </el-form-item>
        <el-form-item label="资源类型：" prop="dev_character">
          <el-select
            v-model="tempPriceItem.dev_character"
            placeholder="请选择资源类型"
            style="width: 100%;"
            @change="handleResourceTypeChange"
          >
            <el-option
              v-for="item in resourceTypeOptions"
              :key="item.type"
              :label="`${item.type}（${item.unitText}）`"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单价：" prop="unit_price">
          <el-input 
            v-model.number="tempPriceItem.unit_price"
            type="number"
            placeholder="请输入单价"
            style="width: 100%;"
          >
            <template slot="suffix">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-switch
            v-model="tempPriceItem.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="tempPriceItem.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button size="small" @click="priceDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="addPriceItem">确定</el-button>
      </div>
    </el-dialog>

    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateOrderDialog',
  props: {
    resourceId: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      default: ''
    },
    resourceRequest: {
      type: Object,
      default: () => ({})
    },
    region: {
      type: String,
      default: ''
    }
  },
  data() {
    const resourceTypeOptions = [
      { type: 'GPU节点', unitCode: '1', unitText: '台·日' },
      { type: 'CPU节点', unitCode: '4', unitText: '台·月' },
      { type: '存储',     unitCode: '3', unitText: 'T·月'  },
      { type: '容器云',   unitCode: '2', unitText: '卡·时' },
      { type: '其他',     unitCode: '4', unitText: '台·月' }
    ];
    return {
      dialogVisible: false,
      createForm: {
        order_no: '',
        contract_no: '',
        customer_name: '',
        ext_01: '',
        resource_type: '',
        order_type: 0,
        starting_time: '',
        end_time: '',
        billing_day: '',
        total_price: '',
        currency: 'CNY',
        dev_number: '',
        status: 0,
        price_items: [],
        region: ''
      },
      price_items: [],
      resourceTypeOptions,
      unitLabelMap: {
        '1': '台·日',
        '2': '卡·时',
        '3': 'T·月',
        '4': '台·月'
      },
      // 附件相关
      fileList: [],
      attachments: [],
      editIndex: -1,
      uploadUrl: '/api-30216/api/orders/upload_file',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
      },
      rules: {
        order_no: [{ required: true, message: '请输入订单名称', trigger: 'blur' }],
        customer_name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        ext_01: [{ required: true, message: '请输入销售人员', trigger: 'blur' }],
        resource_type: [{ required: true, message: '请输入资源类型', trigger: 'blur' }],
        order_type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        billing_day: [
          { required: true, message: '请输入账单日', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseInt(value);
              if (!/^\d+$/.test(value)) {
                return callback(new Error('账单日必须为整数'));
              }
              if (num < 1 || num > 28) {
                return callback(new Error('账单日必须为 1~28 之间的整数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        dev_number: [
          { required: true, message: '请输入设备数量', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseInt(value);
              if (!/^\d+$/.test(value)) {
                return callback(new Error('设备数量必须为非负整数'));
              }
              if (num < 0) {
                return callback(new Error('设备数量不能为负数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        currency: [{ required: true, message: '请选择货币类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择订单状态', trigger: 'change' }],
        total_price: [
          { required: true, message: '请输入总价', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN(num)) {
                return callback(new Error('总价必须为数字'));
              }
              if (num < 0) {
                return callback(new Error('总价不能为负数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        price_items: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少添加一条价格明细'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        starting_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              callback();
            },
            trigger: 'change'
          }
        ],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.createForm.starting_time;
              const endTime = value;

              if (!startTime || !endTime) {
                return callback();
              }

              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change',
            required: true,
          }
        ],
        
      },

      priceDialogVisible: false,
      tempPriceItem: {
        name: '',
        specifications: '',
        dev_character: '',
        metering_unit: '',
        unit_price: null,
        status: 1,
        remark: ''
      },
      priceRules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        metering_unit: [{ required: true, message: '请输入计费单位', trigger: 'blur' }],
        dev_character: [
          { required: true, message: '请选择资源类型', trigger: 'change' }
        ],
        unit_price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { type: 'number', message: '单价必须为数字' },
          { validator: (rule, value, callback) => {
              if (typeof value !== 'number' || isNaN(value)) {
                return callback(new Error('单价必须为有效数字'));
              }
              if (value < 0) {
                return callback(new Error('单价必须大于等于0'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        
      }
    };
  },
  methods: {
    handleResourceTypeChange(value) {
      const selected = this.resourceTypeOptions.find(item => item.type === value);
      if (selected) {
        this.tempPriceItem.metering_unit = selected.unitCode;
      }
    },
    // 添加价格明细
    addPriceItem() {
      this.$refs['priceForm'].validate((valid) => {
        if (valid) {
          this.priceDialogVisible = false;
          this.createForm.price_items.push(this.tempPriceItem);
          this.$refs['createForm'].clearValidate();
          this.tempPriceItem = {
            name: '',
            specifications: '',
            dev_character: '',
            metering_unit: '',
            unit_price: 0,
            status: 1,
            remark: ''
          };
        }
      });
    },
    openDialog() {
      // Pre-fill form fields based on resource request data
      console.log('resourceRequest:', this.resourceRequest);
      console.log('region prop:', this.region);
      if (this.resourceRequest) {
        this.createForm = {
          ...this.createForm,
          customer_name: this.resourceRequest.user_name || '',
          resource_type: `${this.resourceRequest.product_name || ''} ${this.resourceRequest.quantity || ''}台`,
          dev_number: this.resourceRequest.quantity || '',
          starting_time: this.resourceRequest.start_date ? new Date(this.resourceRequest.start_date).toISOString().slice(0, 19).replace('T', ' ') : '',
          end_time: this.resourceRequest.end_date ? new Date(this.resourceRequest.end_date).toISOString().slice(0, 19).replace('T', ' ') : '',
          region: this.region || this.resourceRequest.region || ''
        };
      }
      
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createForm.clearValidate();
      });
    },

    resetForm() {
      const formRef = this.$refs['createForm'];
      if (formRef) {
        formRef.resetFields();
      }
      this.attachments = [];
      this.createForm.price_items = [];
    },

    beforeUpload(file) {
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/zip'
      ];
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('不支持的文件类型！');
        return false;
      }
      return true;
    },

    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200 && response.filePath) {
        this.attachments.push({
          file_name: file.name,
          file_path: response.filePath,
          file_size: file.size
        });
        this.$message.success(`文件 ${file.name} 上传成功`);
      } else {
        this.$message.error(response.message || '文件上传失败');
      }
    },

    handleRemoveAttachment(file, fileList) {
      let filePath = (file.response && file.response.filePath) || file.url || file.name;
      this.attachments = this.attachments.filter(item => item.file_path !== filePath);
    },

    // 打开添加价格弹窗
    openAddPriceDialog() {
      this.tempPriceItem = {
        name: '',
        specifications: '',
        dev_character: '',
        metering_unit: '',
        unit_price: 0,
        status: 1,
        remark: ''
      };
      this.editIndex = -1;
      this.$nextTick(() => {
        this.$refs.priceForm.clearValidate();
      });
      this.priceDialogVisible = true;
    },

    // 编辑 -添加价格明细
    addPriceItem() {
      this.$refs.priceForm.validate(valid => {
        if (!valid) {
          this.$message.error('请填写完整的价格明细信息');
          return;
        }

        const item = {
          ...this.tempPriceItem,
          metering_unit: String(this.tempPriceItem.metering_unit)
        };

        if (this.editIndex === -1) {
          this.createForm.price_items.push(item);
        } else {
          this.createForm.price_items.splice(this.editIndex, 1, item);
        }

        this.priceDialogVisible = false;
        this.editIndex = -1;
      });
    },

    // 编辑价格明细
    editPriceItem(index, row) {
      this.tempPriceItem = { ...row };

      this.$nextTick(() => {
        this.$refs.priceForm.clearValidate();
      });
      this.priceDialogVisible = true;
    },

    // 删除价格明细
    removePriceItem(index) {
      this.createForm.price_items.splice(index, 1);
    },

    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          this.$message.error('请检查表单填写是否完整');
          return;
        }
        if (!this.createForm.price_items || this.createForm.price_items.length === 0) {
          this.$message.error('请至少添加一条价格明细');
          return;
        }

        const postData = {
          order_no: this.createForm.order_no,
          contract_no: this.createForm.contract_no,
          customer_name: this.createForm.customer_name,
          ext_01: this.createForm.ext_01,
          resource_type: this.createForm.resource_type,
          order_type: this.createForm.order_type,
          starting_time: this.createForm.starting_time,
          end_time: this.createForm.end_time,
          billing_day: parseInt(this.createForm.billing_day) || null,
          unit_price: parseFloat(this.createForm.unit_price) || 0,
          total_price: parseFloat(this.createForm.total_price) || 0,
          currency: this.createForm.currency,
          dev_number: parseInt(this.createForm.dev_number) || 0,
          status: this.createForm.status,
          attachments: this.attachments,
          price_items: this.createForm.price_items,
          region: this.createForm.region || '',
          resources: [
            {
              resource_id: this.resourceId,
              products_id: this.productId,
            }
          ]
        };

        try {
          const res = await this.$axios.post('/api-30216/api/orders', postData, {
            headers: {
              'Content-Type': 'application/json'
            },
            transformRequest: [data => JSON.stringify(data)]
          });

          if (res.code === 200) {
            this.$message.success(res.message || '订单创建成功');
            this.dialogVisible = false;
            this.$emit('success');
          } else {
            this.$message.error(res.message || '提交失败，请重试');
          }
        } catch (err) {
          this.$message.error('请求失败，请检查网络或联系管理员');
          console.error('Submit error:', err);
        }
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.el-upload__tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
</style>